import { create } from 'zustand';
import { ApiUtils, ApplicationApi, type ManualApplicationDownloadParams, type StoreBaseReturn } from '@shared/api';

interface UseRejectManualApplicationStore {
  loading: boolean;
  data: boolean;
  error: string | null;
  rejectManualApplication: (searchParams: ManualApplicationDownloadParams, signal?: AbortSignal) => Promise<StoreBaseReturn<boolean>>;
  clear: () => void;
}

export const useRejectManualApplicationStore = create<UseRejectManualApplicationStore>((set) => ({
  loading: false,
  data: false,
  error: null,

  rejectManualApplication: async (searchParams, signal) => {
    try {
      set({ loading: true, data: false, error: null });
      await ApplicationApi.rejectManualApplication(searchParams, signal);
      set({ loading: false, data: true });
      return { loading: false, data: true, error: null };
    } catch (error) {
      set({ loading: false, error: ApiUtils.getApiError(error) });
      return { loading: false, data: false, error: ApiUtils.getApiError(error) };
    }
  },

  clear: () => set({ loading: false, data: false, error: null }),
}));
